import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { internalLearnerGuard } from './core/auth/internal-learner.guard';
import { roleGuard } from './core/auth/role.guard';
import { Role } from './core/models/role.enum';
import { AppPaths } from './core/routing/app-paths';

export const routes: Routes = [
  {
    path: AppPaths.connecting,
    loadComponent: () =>
      import('./features/auth/connecting/connecting.component').then((m) => m.ConnectingComponent)
  },
  {
    path: AppPaths.connexion,
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES)
  },
  {
    path: AppPaths.etudiant,
    // canActivate: [authGuard, roleGuard([Role.Student])],
    loadChildren: () => import('./features/student/student.routes').then((m) => m.STUDENT_ROUTES)
  },
  {
    path: AppPaths.formateur,
    canActivate: [authGuard, roleGuard([Role.Instructor, Role.Admin, Role.Pedagogie])],
    loadChildren: () => import('./features/instructor/instructor.routes').then((m) => m.INSTRUCTOR_ROUTES)
  },
  {
    path: AppPaths.admin,
    canActivate: [authGuard, roleGuard([Role.Admin, Role.Pedagogie])],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
  },
  {
    path: AppPaths.vieScolaire,
    canActivate: [authGuard, roleGuard([Role.VieScolaire, Role.Admin, Role.Pedagogie])],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
  },
  {
    path: AppPaths.pedagogie,
    canActivate: [authGuard, roleGuard([Role.Pedagogie, Role.Admin])],
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
  },
  {
    path: AppPaths.createurContenu,
    canActivate: [authGuard, roleGuard([Role.ContentCreator, Role.Admin])],
    loadChildren: () =>
      import('./features/content-creator/content-creator.routes').then((m) => m.CONTENT_CREATOR_ROUTES)
  },
  {
    path: AppPaths.mesFormations,
    canActivate: [authGuard, internalLearnerGuard],
    loadChildren: () =>
      import('./features/collaborateur/collaborateur.routes').then((m) => m.COLLABORATEUR_ROUTES)
  },
  // Legacy English paths → French
  { path: 'login', redirectTo: AppPaths.connexion, pathMatch: 'prefix' },
  { path: 'student', redirectTo: AppPaths.etudiant, pathMatch: 'prefix' },
  { path: 'instructor', redirectTo: AppPaths.formateur, pathMatch: 'prefix' },
  { path: 'content-creator', redirectTo: AppPaths.createurContenu, pathMatch: 'prefix' },
  { path: 'connexion-en-cours', redirectTo: AppPaths.connecting, pathMatch: 'full' },
  { path: '', redirectTo: AppPaths.connexion, pathMatch: 'full' },
  { path: '**', redirectTo: AppPaths.connexion }
];
